module.exports = __webpack_public_path__ + "img/greathall64_ua.b6810f44.webp";